import { parseCsv } from "@ryoma/engine";
import { Workbook } from "./xlsx.ts";

export interface LoadedTable {
  fileName: string;
  headers: string[];
  rows: Record<string, unknown>[];
  sheetNames: string[];
  sheet: string | null;
}

const MAX_BYTES = 50 * 1024 * 1024;

/** Read a CSV or Excel file in the browser. Nothing is sent anywhere. */
export async function loadTable(file: File, sheet?: string): Promise<LoadedTable> {
  if (file.size > MAX_BYTES) throw new Error("File is over 50 MB; split it or export fewer columns");
  const name = file.name.toLowerCase();
  if (name.endsWith(".xlsx")) {
    const wb = await Workbook.open(await file.arrayBuffer());
    const chosen = sheet ?? wb.sheetNames[0] ?? "";
    const s = await wb.sheet(chosen);
    return { fileName: file.name, headers: s.headers, rows: s.rows, sheetNames: wb.sheetNames, sheet: chosen };
  }
  if (name.endsWith(".xls")) throw new Error("Old .xls files are not supported; save as .xlsx or CSV");
  const t = parseCsv(await file.text());
  return { fileName: file.name, headers: t.headers, rows: t.rows, sheetNames: [], sheet: null };
}
